module.exports = __webpack_public_path__ + "img/coach-landing.9e506c3f.svg";